import Vue from 'vue'
import _ from 'lodash'
import cookies from 'js-cookie'
import router from './router'

import app from './app'
import api from './plugins/api'
import logger from './plugins/logger'
import config from './plugins/config'

import './plugins/axios'
import './plugins/elementUI'
// import './assets/font-awesome/css/font-awesome.css'
import './assets/iconfont/iconfont.css'
import './assets/css/alpha.css'
import './assets/css/radish.css'

import * as misc from './misc'
import registerComponents from './plugins/components'
import { checkFp } from './commons/fingerPrint'

registerComponents()
Vue.config.productionTip = false
window._ = _
app.config = config
app.api = api
Vue.directive('drag', {
  // bind: el => {
  //   let odiv = el
  //   // 获取当前元素
  //   odiv.onmousedown = event => {
  //     // 算出鼠标相对元素的位置
  //     /* 获取当前鼠标的坐标 */
  //     var mouseX = event.pageX
  //     var mouseY = event.pageY
  //     document.onmousemove = e => {
  //       // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
  //       var x = e.pageX - mouseX
  //       var y = e.pageY - mouseY
  //       // 绑定元素位置到positionX和positionY上面
  //       /* this.positionX = top
  //       this.positionY = left */
  //       // 移动当前元素
  //       odiv.style.left = x + 'px'
  //       odiv.style.top = y + 'px'
  //     }
  //     document.onmouseup = e => {
  //       document.onmousemove = null
  //       document.onmouseup = null
  //     }
  //   }
  // }
})

const checkFpIfNeed = async user => {
  // if (
  //   (!user.角色 || !user.角色.includes('管理员')) &&
  //   (cookies.get('redirect_url') && !cookies.get('redirect_url').includes('/collectFp'))
  // ) {
  //   await checkFp()
  // }
  if (!user.角色 || !user.角色.includes('管理员')) {
    const isSafe = await safetyCheck(user)
    if (!isSafe) {
      window.alert(`当前设备未经授权，请添加管理员微信：17320693989`)
      await logout()
    }
    // if (!window.location.href.includes('/collectFp?code=')) {
    // await checkFp()
  }
}

const logout = async () => {
  await app.logout()
  window.location.reload()
}

const checkPluginInstallState = async () => {
  return new Promise((resolve, reject) => {
    const extensionid = 'gckikmojnkkdcgefakebleffdfcmgmdi'
    const image = document.getElementById('hidden-img-for-check-plugin')
    image.src = `chrome-extension://${extensionid}/icons/19.png`
    image.onerror = () => {
      resolve(false)
    }
    image.onload = () => {
      resolve(true)
    }
  })
}

const safetyCheck = async user => {
  if (user.角色 && user.角色.includes('mac用户')) {
    const isInstallPlugin = await checkPluginInstallState()
    return isInstallPlugin
  }
  const mac = localStorage.getItem('mac')
  const isMac =
    mac && /[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}/.test(mac)
  if (!isMac) {
    return false
  }
  const isInstallPlugin = await checkPluginInstallState()
  return isInstallPlugin
}
const authenticate = () =>
  app
    .authenticate()
    .catch(() => {
      new Vue({
        el: '#auth',
        render(h) {
          if (/MicroMessenger/i.test(window.navigator.userAgent)) {
            return h(misc.mobileLogin)
          } else {
            return h(misc.login)
          }
        },
      })
      return new Promise(resolve => app.on('login', ({ accessToken }) => resolve({ accessToken })))
    })
    .then(async ({ accessToken }) => {
      let cookie
      cookie = `feathers-jwt=${accessToken};expires=`
      cookie += new Date(Date.now() + 1000 * 60 * 60).toGMTString()
      document.cookie = cookie
      const user = await app.api.getProfile({})
      const gray = cookies.get('gray')
      const isExpUser = user.体验用户
      if (isExpUser && (!gray || gray !== 'exp')) {
        cookies.set('gray', 'exp', { expires: 7 })
        window.location.reload()
      } else if (!isExpUser && gray) {
        cookies.remove('gray')
        window.location.reload()
      }
      return new Promise(resolve => resolve(user))
    })
    .catch(error => {
      console.error(error)
    })

const authenticate2 = () => {
  app
    .authenticate()
    .then(async user => {
      try {
        await checkFpIfNeed(app.user)
      } catch (e) {
        console.error(e)
      }
    })
    .catch(error => {
      console.log('登陆过期', error)
      window.location.reload()
    })
}

const start = async () => {
  await app.get('serviceExtensions')

  if (window.location.href.indexOf('47.94.156.98') !== -1) {
    app.name = 'test'
  } else if (
    window.location.href.indexOf('http://localhost') !== -1 ||
    window.location.href.indexOf('http://127.0.0.1') !== -1
  ) {
    app.name = 'dev'
  } else if (window.location.host === '47.95.9.255:3300') {
    app.name = 'syn'
  } else {
    app.name = 'core'
  }

  if (window.location.href.match(/localhost/)) {
    window.host = 'http://localhost:3200'
    window.frontend = 'http://localhost:8080'
  } else {
    window.host = window.location.origin
    window.frontend = window.host
  }

  const isChrome = window.navigator.userAgent.indexOf('Chrome') !== -1
  const isWechat = /MicroMessenger/i.test(window.navigator.userAgent)
  if (!isChrome && !isWechat) {
    return (window.location.href = `${window.frontend}/not.html`)
  }

  logger.config(app)

  authenticate()
    .then(async user => {
      app.user = user

      const cannotLoginCore = user.禁止登录核心系统
      if (cannotLoginCore && !/MicroMessenger/i.test(window.navigator.userAgent)) {
        window.alert('您的账号无法登陆核心系统')
        app.logout().then(() => window.location.reload())
      }

      await checkFpIfNeed(app.user)
      app.getProjects = async () => {
        const pros = await app.service('project').simpleProjects()
        if (pros.status === 200) {
          app.projects = pros.data
        } else {
          console.log(pros.message)
        }
      }
      await app.getProjects()
      app.getCats = async () => {
        const cats = await app.service('misc').simpleCategories()
        if (cats.status === 'success') {
          app.categories = cats.data
        } else {
          console.log(cats.msg)
        }
      }
      await app.getCats()
      app.getUsers = async () => {
        const users = await app.service('misc').listAccounts()
        if (users.status === 'success') {
          app.users = users.data
          app.accounts = users.data.filter(v => !['离职中', '已离职'].includes(v.状态)).map(u => u.account)
          app.accountWithQRCode = users.data.map(u => ({
            value: u.account,
            label: u.account,
            children: Object.keys(u.qrcodes || {}).map(val => ({ value: (u.qrcodes || {})[val], label: val })),
          }))
          app.kehuziyuanOpt = Array.from(new Set(users.data.map(u => u.kehuziyuanOpt || []).flat()))
        } else {
          console.log(users.msg)
        }
      }
      await app.getUsers()
      // app.getIndustries = async () => {
      const industries = await app.service('misc').listIndustries()
      if (industries.status === 'success') {
        app.industries = industries.data.map(u => u.名称)
        app.industriesAll = industries.data
      } else {
        console.log(industries.msg)
      }
      // }
      return new Vue({
        el: '#app',
        router,
        render(h) {
          return h(misc.app)
        },
      })
    })
    .catch(e => {
      console.error(e)
    })

  app.setLoginInterval = () => {
    // 10min 校验一次
    app.loginInterval = setInterval(authenticate2, 1000 * 60 * 10)
  }
  app.setLoginInterval()

  window.router = router

  window.onerror = function(message, source, lineno, colno, error) {
    console.log(message, source, lineno, colno, error)
  }
  document.addEventListener('contextmenu', e => {
    e.preventDefault()
  })

  window.addEventListener('unhandledrejection', event =>
    alert(`WARNING: Unhandled promise rejection. Reason: ${event.reason}`),
  )
}

start()
